import usersReducer, { USERS_DEFAULT_STATE } from "./users";
import emailsReducer, { EMAILS_DEFAULT_STATE } from "./emails";

export const reducer = {
  users: usersReducer,
  emails: emailsReducer
};

export const DEFAULT_STATE = {
  users: USERS_DEFAULT_STATE,
  emails: EMAILS_DEFAULT_STATE
}